// extracted by mini-css-extract-plugin
export default {"app":"app_app__OsQoD","header":"app_header__MWnrU","main":"app_main__Mk+bc"};